// General (A12U11, D183): every role reads it; owners and admins change it (GeneralForm).
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { GeneralForm } from '../../../../features/organization/GeneralForm'
import { OrgSection } from '../../../../features/organization/OrgSection'
import { orgQuery } from '../../../../features/settings/queries'
import { accessQuery } from '../../../../shared/access/access'
import { Part } from '../../../../shared/shell/StatePart'

export const Route = createFileRoute('/o/$orgSlug/organization/general')({
  staticData: { screenId: 'OrgSettingsScreen', access: 'settings.read', ownHeader: true },
  loader: async ({ context: { queryClient, membership } }) => {
    await Promise.all([
      queryClient.ensureQueryData(orgQuery(membership.orgId)),
      queryClient.ensureQueryData(accessQuery(membership.orgId)),
    ])
    return { orgId: membership.orgId, orgName: membership.name }
  },
  component: OrgSettingsScreen,
})

function OrgSettingsScreen() {
  const { t } = useTranslation()
  const { orgId, orgName } = Route.useLoaderData()
  return (
    <OrgSection
      orgId={orgId}
      section="general"
      root={ids.orgSettings.root}
      title={t('organization.section.general')}
      subtitle={t('organization.general.subtitle', { name: orgName })}
    >
      <Part>
        <GeneralForm orgId={orgId} />
      </Part>
    </OrgSection>
  )
}
